import app from "@/app.js";
import LogTLCard from "@/components/LogTLCard1.vue";
import TransTLCard from "@/components/TransTLCard1.vue";
import CardTransactionsTable from "@/components/CardTransTable.vue";
import CardLogsTable from "@/components/CardLogsTable.vue";
import CardStatPanel from "@/components/CardStatPanel.vue";
import CardProfilePanel from "@/components/CardProfilePanel.vue";
import CardMainPanel from "@/components/CardMainPanel.vue";

function compare(a, b) {
    if (a.created < b.created) return 1;
    if (a.created > b.created) return -1;
    return 0;
}

export default {
    components: {
        /*CardRecord,*/
        LogTLCard,
        TransTLCard,
        CardStatPanel,
        CardTransactionsTable,
        CardLogsTable,
        CardProfilePanel,
        CardMainPanel,
    },
    data() {
        return {
            snackbar: false,
            snackbarMsg: "ok",
            snackbarColor: false,
            loaded: false,
            byLogt: "",
            COLOR_MINUS: app.COLOR_MINUS,
            COLOR_PLUS: app.COLOR_PLUS,
            mainPanels: [0],
            editType: "Cardrecord",
            startValid: null,
            lastValid: null,
            byLog: false,
            reverse: false,
            tab: null,
            card: {},
            activated: null,
            cardDetails: [],
            cardTransactions: [],
            cardLog: [],
            //cardTimeLine: [],
            logCols: [
                {
                    name: "card.field.created",
                    value: "created",
                    align: "left",
                    filter: "dt-time",
                },
                { name: "field.subcompany", value: "subcompany", align: "center" },
                { name: "field.terminal", value: "terminal", align: "center" },
                {
                    name: "card.field.command",
                    value: "command",
                    align: "center",
                    filter: "command",
                },
                {
                    name: "field.amount1.",
                    value: "p1",
                    filter: "currency",
                    align: "right",
                },
                {
                    name: "field.amount2.",
                    value: "p2",
                    filter: "currency",
                    align: "right",
                },
                {
                    name: "card.field.resp3",
                    value: "resp3",
                    filter: "currency",
                    align: "right",
                },
                {
                    name: "card.field.message",
                    value: "message",
                    align: "center",
                },
                // {
                //   name: "field.code",
                //   value: "code",
                //   align: "center",
                // },
            ],
            transCols: [
                {
                    name: "card.field.created",
                    value: "created",
                    align: "left",
                    filter: "dt-time",
                },
                { name: "field.subcompany", value: "subcompany", align: "center" },
                { name: "field.terminal", value: "terminal", align: "center" },
                {
                    name: "field.status",
                    value: "status",
                    align: "center",
                    filter: "status",
                },
                {
                    name: "field.amount1.",
                    value: "amount1",
                    align: "right",
                    filter: "currency",
                },
                {
                    name: "field.amount2.",
                    value: "amount2",
                    align: "right",
                    filter: "currency",
                },
                {
                    name: "field.debit_0",
                    value: "debit_0",
                    align: "right",
                    filter: "currency",
                },
                // {
                //   name: "field.debit_n",
                //   value: "debit_n",
                //   align: "right",
                //   filter: "currency"
                // }
            ],
            cardDets: [
                {
                    name: "",
                    value: "oper_nr",
                },
                {
                    name: "card.acc.operation",
                    value: "operation",
                },
                {
                    name: "card.field.ocreated",
                    value: "created",
                    align: "center",
                    filter: "dt-only",
                },
                {
                    name: "field.debit_0",
                    value: "amount_debit",
                    align: "right",
                    filter: "currency",
                },
                {
                    name: "field.last_used",
                    value: "last_used",
                    align: "center",
                    filter: "dt-time",
                },
                {
                    name: "card.acc.used",
                    value: "used",
                    align: "center",
                },
                {
                    name: "card.acc.valid",
                    value: "valid",
                    align: "right",
                    filter: "dt-time",
                },
                // "amount_discount",
                // "current_discount",
                // "points_bonus",
                // "amount_bonus",
                //"status"
            ],
        };
    },
    computed: {
        cardSystem() {
            try {
                return this.card.system ? this.card.system : "";
            } catch (e) {
                return "";
            }
        },
        isTimeLines() {
            try {
                return this.cardTransactions.length > 0 || this.cardLog.length > 0;
            } catch (e) {
                return false;
            }
        },
        isDetail() {
            try {
                return this.cardDetails.length > 0;
            } catch (e) {
                return false;
            }
        },
        isTransactions() {
            try {
                return this.cardTransactions.length > 0;
            } catch (e) {
                return false;
            }
        },
        isLogs() {
            try {
                return this.cardLog.length > 0;
            } catch (e) {
                return false;
            }
        },
        debet() {
            if (this.cardDetails.length == 0) return 0;
            let debet = 0;
            this.cardDetails.forEach((e) => {
                if (e.oper_nr == 0) debet += e.amount_debit;
            });
            return debet;
        },
        timeLineItems() {
            if (this.byLog && this.cardLog) {
                return this.reverse ? this.cardLog.slice().sort(compare) : this.cardLog;
            } else if (this.cardTransactions.length) {
                return this.reverse
                    ? this.cardTransactions.slice().sort(compare)
                    : this.cardTransactions;
            }
            return [];
        },
    },
    methods: {
        copyCard(id) {
            app.copyDiv(id);
        },
        onUpdateRecord() {
            this.getCardInfo(true);
        },
        onInsertRecord() { },
        onDeleteRecord() { },
        getCardInfo(s) {
            let card = this.$route.params.id;

            if (card.indexOf("=") != -1) {
                card = card.substr(0, card.indexOf("="));
            }
            app
                .getCardInfo(card, s)
                .then((response) => {
                    this.card = response.card;
                    this.newStatus = this.card.status;
                    this.newPin = this.card.pin;
                    if (s) return;
                    try {
                        this.lastValid = this.$moment(this.card.valid);
                    } catch (e) {
                        this.lastValid = null;
                    }
                    this.startValid = this.$moment(this.card.created);
                    this.cardDetails = response.details;
                    this.cardDetails.forEach((e) => {
                        if (e.oper_nr == 0) {
                            this.startValid = this.$moment(e.created);
                        }
                        let v = this.$moment(e.valid);
                        if (v.isBefore(this.lastValid)) this.lastValid = v;
                    });
                    this.cardLog = response.logs;
                    this.cardTransactions = response.trans;
                    // if (this.cardLog.length > 0) {
                    //   this.byLog = true;
                    //   this.cardTimeLine = this.cardLog.slice().sort(compare);
                    // } else {
                    //   this.byLog = false;
                    //   this.cardTimeLine = this.cardTransactions.slice().sort(compare);
                    // }
                    if (!this.cardLog.length && !this.cardTransactions.length)
                        this.mainPanels = null;
                    this.loaded = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        tlIcon(v) {
            if (v.command) {
                if (v.code != 0) return "fa-bug";
                if (v.command == 1100) return "fa-info";
            } else {
                //trans
                if (v.status == 200) {
                    return v.amount1 ? "fa-shopping-cart" : "fa-money-bill-wave";
                }
                if (v.status == 201) return "fa-exclamation";
                if (v.status == 202) return "fa-times-circle";
            }
            return null;
        },
        tlColorIcon(v) {
            if (v.status) {
                if (v.status == 200) {
                    return v.amount2 ? app.COLOR_PLUS : app.COLOR_MINUS;
                } else {
                    return "#E0E0E0";
                }
            }
            if (v.code != 0) return "error";
            if (v.command == 1100) return "#FFECB3";
            return "#E0E0E0";
        },
        tlColor(v) {
            if (v.command) {
                // log
                if (v.code == 0 && v.command == 1200) {
                    return v.p1 ? app.COLOR_MINUS : app.COLOR_PLUS;
                } else if (v.code != 0) {
                    return "error";
                }
            } else {
                //trans

                if (v.status == 200) {
                    return v.amount2 ? app.COLOR_PLUS : app.COLOR_MINUS;
                } else {
                    return "#E0E0E0";
                }
            }
            return "secondary";
        },
        tlSmall(v) {
            if (v.command) {
                return (v.command == 1200 || v.command == 1300) && v.code == 0
                    ? true
                    : false;
            }
            return false;
        },
        tlLeft() {
            return true;
        },
        autoformat(col, val) {
            if (col == "dt-only") {
                return this.$options.filters["dt-only"](val);
            }
            if (col == "dt-time") return this.$options.filters["dt-time"](val);
            if (col == "currency") return this.$options.filters.currency(val);
            if (col == "amount1") return this.$options.filters.currency(val);
            if (col == "amount2") return this.$options.filters.currency(val);
            if (col == "debit_0") return this.$options.filters.currency(val);
            if (col == "debit_n") return this.$options.filters.currency(val);
            if (col == "amount_discount") return this.$options.filters.currency(val);
            if (col == "amount_debit") return this.$options.filters.currency(val);
            if (col == "amount_bonus") return this.$options.filters.currency(val);
            if (col == "last_used") return this.$options.filters["dt-time"](val);
            if (col == "created") return this.$options.filters["dt-only"](val);
            return val;
        },
    },
    mounted() {
        this.getCardInfo();
    },

}